/**
 * Cart Utilities
 *
 * Shared helpers for updating the WooCommerce cart count in the page header.
 * Used by both streaming (ChatContext) and non-streaming (ChatMessage) paths.
 */
/**
 * Fetch the current cart item count from the Store API and update every
 * cart-count element on the page.  Best-effort — errors are silently ignored.
 */
export async function updateCartCountInHeader() {
    try {
        const cartRes = await fetch('/wp-json/wc/store/v1/cart', {
            credentials: 'include',
        });
        if (!cartRes.ok)
            return;
        const cartData = await cartRes.json();
        const count = cartData.items_count ?? 0;
        // Update ALL common cart count selectors
        const selectors = [
            '.cart-contents .count',
            '.cart-count',
            '.header-cart-count',
            '.mini-cart-count',
            '.woocommerce-cart-count',
            '.site-header-cart .count',
            '.cart-contents-count',
            '.header-cart .badge',
            // Donkey Table theme: button.header__cart-button > span
            '.header__cart-button span',
            '.header__cart-button .cart-count',
            // Extra selectors that were only in the ChatMessage local version
            '.cart-contents span',
            '.header__action-count',
            '#products-count',
            '[data-cart-count]',
        ];
        selectors.forEach(sel => {
            document.querySelectorAll(sel).forEach(el => {
                el.textContent = count.toString();
            });
        });
        // Also update data attributes
        document.querySelectorAll('[data-cart-count]').forEach(el => {
            el.setAttribute('data-cart-count', count.toString());
        });
        // Generic fallback: find any numeric badge inside a cart link/button in the header
        document.querySelectorAll('header span, header sup, header em, .header span, .site-header span, nav span, #masthead span').forEach(el => {
            const text = el.textContent?.trim() ?? '';
            const parent = el.closest('a[href*="cart"], button[class*="cart"], [class*="cart-button"], [class*="cart-icon"]');
            if (parent && /^\d+$/.test(text)) {
                el.textContent = count.toString();
            }
        });
        // WC Blocks event for modern themes
        document.body.dispatchEvent(new CustomEvent('wc-blocks_added_to_cart'));
    }
    catch {
        // Cart count update is best-effort — never throw
    }
}
